import Vue from 'vue'
import {ToastPlugin, ModalPlugin} from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import useJwt from '@/auth/jwt/useJwt'
import {i18n} from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'
import {ApiCache} from "@core/api";

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

Vue.use(require('vue-moment'));

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

useJwt.onAuthenticationFailed(() => {
    ApiCache.authenticationFailed();
    if (router.currentRoute.name !== 'auth-login') {
        store.dispatch('logout');
        router.replace('/login');
    }
});

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app')
